import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ValueDriversComponent } from './value-drivers';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  declarations: [
    ValueDriversComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    ValueDriversComponent
  ]
})
export class ValueDriversComponentModule {}


// WEBPACK FOOTER //
// ./src/components/value-drivers/value-drivers.module.ts